import { z } from 'zod';

export const storeAddOnGroupSchema = z.object({
    name:        z.string().min(1, 'Name is required').max(255),
    description: z.string().max(1000).nullable().optional(),
    addon_ids:   z.array(z.string().uuid()).optional(),
});

export type AddOnGroupFormValues = z.infer<typeof storeAddOnGroupSchema>;
